// const s = require("./sheetHeader.module.scss");

import { default as React } from "react";
import DownloadButton from "components/downloadButton";
import { ApplicationState } from "core/app";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

interface State {
    applicationState: ApplicationState;
    title: string;
    senderId: string;
    showDownload: boolean;
    showTestData?: boolean;
    disclaimer: string;
}

const SheetHeader = (props: any) => { //{ applicationState, title, pageConfig, showDownload }: State
    return <header className="sheetHeader" style={{ display: "block", backgroundColor: "white", zIndex: 4 }}>
        {props.showDownload && <DownloadButton applicationState={props.applicationState} pageConfig={props.pageConfig} formats={props.downloadFormats || ["xml", "csv"]} />}
        {props.children /* Explanatory note, or other buttons on top */}
        <h3 className="mr-auto" style={{ color: "#A60045", padding: "30px", margin: "0" }}>{props.title}</h3>
        {props.showTestData && <h4 className="mr-auto" style={{ color: "#aaa", paddingLeft: "30px", margin: "0", marginTop: "-33px", position: "absolute" }}>Test data.
            <a href="/ibwt" style={{ fontSize: "14pt" }}>Full Disclaimer</a>
        </h4>
        }
        {props.disclaimer && <div style={{ background: "lightyellow", paddingLeft: "15px", paddingRight: "10px", color: "darkorange" }}>
            <FontAwesomeIcon icon={faInfoCircle} style={{ fontSize: "17x", verticalAlign: "middle", margin: "-6px 6px 0 6px" }} />
            {props.disclaimer}
        </div>
        }
    </header>;
};
export default SheetHeader;